<template>
  <div id="product">
    <div class="general-header container">
      <div class="title-box">
        <h3 class="cate-title">{{ detail.name }}</h3>
        <p class="cate-model">{{ detail.model }}</p>
      </div>
      <div class="visible-xs" style="clear: both"></div>
      <div class="fake">
        <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '/' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="cate.path">{{
            cate.name
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ detail.name }}</el-breadcrumb-item>
              </el-breadcrumb
        >
      </div>
    </div>
    <div class="product-box container">
      <div>
        <img :src="bigView" class="big-img" alt="" />
        <ul class="img-list">
          <li
            v-for="(item, index) in detail.imgList"
            @click="changeView(item)"
            :key="index"
          >
            <img :src="item" alt="" />
          </li>
        </ul>
      </div>
      <div style="clear: both; margin-bottom: 20px"></div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="产品概述" name="first">
          <div class="pane-box" v-html="detail.overview"></div>
        </el-tab-pane>
        <el-tab-pane label="详细参数" name="second">
          <div class="pane-box" v-html="detail.parameter"></div>
        </el-tab-pane>
        <el-tab-pane label="资料下载" name="third">
          <div class="pane-box" v-html="detail.download"></div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Daily from "../../assets/data/goods-list.js";
export default {
  name: "product-detail",
  data() {
    return {
      activeName: "first",
      kind: "",
      bigView: "",
      cate: [],
      detail: [],
    };
  },
  created() {
    this.filterKind();
  },
  watch: {
    $route() {
      this.filterKind();
    },
  },
  methods: {
    showClassify() {
      this.$store.commit("set_true");
    },
    leaveFun() {
      this.$store.commit("set_false");
    },
    filterKind() {
      this.kind = this.$route.params.id;
      this.goodsList = Daily.goods;
      for (let i = 0; i < this.goodsList.length; i++) {
        var good = this.goodsList[i].child;

        for (let j = 0; j < good.length; j++) {
          if (good[j].id === this.kind) {
            this.cate.key = this.goodsList[i].id;
            this.cate.path = "/product/" + this.goodsList[i].id;
            this.cate.name = this.goodsList[i].kind;
            this.detail = good[j];
            this.bigView = this.detail.path;
          }
        }
      }
    },
    changeView(img) {
      this.bigView = img;
    },
  },
};
</script>

<style scoped lang="less">
#product {
  .general-header {
    border-bottom: 1px solid #dddddd;
    padding: 21px 0;
    .title-box {
      display: inline-block;
      min-width: 230px;
      .cate-title {
        margin: 0 0 10px;
        display: inline-block;
      }
      .cate-model {
        color: #bbbbbb;
        margin-bottom: 0;
        line-height: 18px;
        font-size: 18px;
      }
    }

    .el-breadcrumb {
      padding: 0 10px;
      vertical-align: bottom;
      display: inline-block;
      .el-breadcrumb__inner a,
      .el-breadcrumb__inner.is-link {
        font-weight: normal;
        color: #606266;
      }
    }
  }
  .product-box {
    padding: 20px 0px 100px;
    .big-img {
      border: 1px solid #dddddd;
      width: 260px;
      height: 260px;
      margin-bottom: 12px;
    }
    .img-list {
      li {
        float: left;
        margin-right: 12px;
        width: 60px;
        height: 60px;
        border: 1px solid #dddddd;
        transition: all 0.2s;
        &:hover {
          border: 1px solid #004ca0;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .pane-box {
      width: 60%;
      p {
        margin-bottom: 0 !important;
        span {
          font-size: 16px !important;
          line-height: 1.8 !important;
          max-width: 800px !important;
        }
      }
    }
  }
}
</style>
<style lang="less">
.general-header {
  .fake {
    display: inline-block;
    position: relative;
    .fake-span {
      opacity: 0;
      z-index: 99;
      position: absolute;
      left: 65px;
      top: 2px;
      display: block;
      width: 60px;
      height: 16px;
      background-color: red;
    }
    .el-breadcrumb {
      padding: 0 10px;
      .el-breadcrumb__inner {
        line-height: 20px;
      }
      .el-breadcrumb__inner a,
      .el-breadcrumb__inner.is-link {
        font-weight: normal;
        color: #606266;
      }
    }
  }
}
.product-box {
  .el-tabs__nav-scroll {
    background-color: #f7f7f7;
    .el-tabs__active-bar {
      display: none;
    }
    .el-tabs__item.is-active {
      background-color: #1f3d96;
      color: #ffffff;
    }
    .el-tabs__item {
      padding: 0 20px !important;
    }
  }
  .el-tab-pane {
    .no-border {
      td {
        border: none;
      }
    }
    table {
      width: 90%;
      .uniform-height {
        img {
          height: 120px;
        }
      }
      td,
      th {
        text-align: center;
        vertical-align: middle;
      }
      td {
        padding: 6px 8px;
        border: 1px solid rgb(221, 221, 221);
        img {
          width: 60%;
        }
      }
      p {
        margin-bottom: 0 !important;
        img {
          width: 80%;
        }
      }
    }
  }
}
@media (max-width: 868px) {
  #product .product-box .pane-box {
    width: 92% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/product-detail.vue